// =============================================================================
// DATA / PHOTO.JS — Photographers & videographers
// Field order: Services → Pricing → Coverage → Turnaround → Style
//   → Travel → Banff Permit → Experience → Email → Instagram → Website
// =============================================================================

export const photoData = [
  { name: "Light Delight Photography", tier: "$", fields: [
    { label: "Services", value: "Photography; highlight video reel for select weddings" },
    { label: "Pricing", value: "Elopements from $900" },
    { label: "Coverage", value: "2-hour elopements to multi-day weddings" },
    { label: "Turnaround", value: "3–8 weeks" },
    { label: "Travel", value: "Calgary, Canmore & Banff" },
    { label: "Banff Permit", value: "Yes ✓" },
    { label: "Experience", value: "14+ years" },
    { label: "Instagram", value: "@lightdelightphotography" },
    { label: "Website", value: "lightdelightphotography.ca", link: "https://www.lightdelightphotography.ca" },
  ]},
  { name: "Lindsay Fontaine", tier: "$/$$", fields: [
    { label: "Services", value: "Photo, video, or hybrid; film photography option available" },
    { label: "Pricing", value: "Photo or video from $3,500; hybrid from $5,750" },
    { label: "Coverage", value: "10 hours standard; customizable" },
    { label: "Turnaround", value: "Photos 3 months; Video 6 months" },
    { label: "Style", value: "Vibrant, true-to-life; balanced posed and candid" },
    { label: "Travel", value: "All of Alberta complimentary" },
    { label: "Experience", value: "Since 2017" },
    { label: "Instagram", value: "@fontaine_photo_film" },
    { label: "Website", value: "lindsayfontaine.com", link: "https://lindsayfontaine.com/" },
  ]},
  { name: "TK Shotz Productions", tier: "$/$$", fields: [
    { label: "Services", value: "Photo, video, film, Super8 & photo booths" },
    { label: "Pricing", value: "Premier package $4,948" },
    { label: "Coverage", value: "10–12 hours; 2 shooters included in all packages" },
    { label: "Turnaround", value: "30–45 days" },
    { label: "Travel", value: "Calgary, Canmore & Banff — no travel fees" },
    { label: "Experience", value: "Since 2007" },
    { label: "Email", value: "info@tkshotz.com" },
    { label: "Instagram", value: "@tkshotz" },
    { label: "Website", value: "tkshotz.com", link: "https://www.tkshotz.com" },
  ]},
  { name: "Rose and Range Photography", tier: "$$", fields: [
    { label: "Services", value: "Photography & videography — digital and film" },
    { label: "Pricing", value: "From $4,900" },
    { label: "Coverage", value: "8 hours to unlimited for Saturday weddings" },
    { label: "Turnaround", value: "8 weeks" },
    { label: "Style", value: "Candid, elegant, and romantic" },
    { label: "Travel", value: "Mountains and beyond" },
    { label: "Instagram", value: "@roseandrangephoto" },
    { label: "Website", value: "roseandrangephotography.ca", link: "http://www.roseandrangephotography.ca/" },
  ]},
  { name: "Erika Lagy Photography", tier: "$$/$$$ ", fields: [
    { label: "Services", value: "Photography only — film & digital combined" },
    { label: "Pricing", value: "From $5,000; most couples invest $6,500–$7,000" },
    { label: "Coverage", value: "8–12 hours; 2nd photographer for 10 & 12-hour packages" },
    { label: "Turnaround", value: "8–12 weeks" },
    { label: "Style", value: "Documentary and editorial — timeless and artistic" },
    { label: "Travel", value: "Canmore & Banff included" },
    { label: "Experience", value: "10+ years" },
    { label: "Email", value: "info@erikalagyphotography.com" },
    { label: "Instagram", value: "@erikalagyphoto" },
    { label: "Website", value: "erikalagyphotography.com", link: "https://erikalagyphotography.com" },
  ]},
  { name: "Twisted Film Works", tier: "$$", fields: [
    { label: "Services", value: "Videography only" },
    { label: "Pricing", value: "From $4,500 + GST" },
    { label: "Coverage", value: "6–12 hours; second shooter available" },
    { label: "Turnaround", value: "Teaser film within 2 weeks; final film within 3 months" },
    { label: "Style", value: "Candid with a romantic flare" },
    { label: "Experience", value: "12+ years — all weather and lighting conditions from the Rockies to Drumheller" },
    { label: "Travel", value: "All of Alberta and Canada" },
    { label: "Email", value: "hello@twistedfilmworks.com" },
    { label: "Instagram", value: "@twistedfilmworks" },
    { label: "Website", value: "twistedfilmworks.com", link: "https://twistedfilmworks.com" },
  ]},
];


export const photoPending = ["Jenny Jean Photography @jennyjeanphotography", "Greco Photo Co. @grecophotoco", "Nicole Sarah Photography @nicolesarahwedding", "Gabe McClintock Photography @gabemcclintock", "Alexandra Weddings @_alexandra_weddings", "Fly Free Photo & Film @flyfreeweddings", "Meghan Fenton @meghanfentonphoto"];
